/**
 * Labels animation, animated dropdown, autosize textarea, custom file inputs
 *
 * Usage:
 * document.addEventListener('DOMContentLoaded', () => {
 *   formInputs(document.body);
 * })
 */

import Dropkick from 'dropkickjs';
import 'nodelist-foreach-polyfill';
import fitTextarea from 'fit-textarea';
import uploadFile from 'components/upload-file/upload-file';
import 'components/upload-file/upload-file.scss';

function formInputs(container) {
  const textareas = [];
  const nodelist = container.querySelectorAll('[data-autosize-textarea]');
  if (nodelist) {
    nodelist.forEach(el => textareas.push(el));
    fitTextarea.watch(textareas);
  }

  uploadFile(container);

  container.querySelectorAll('.form-input-block').forEach((inputBlock) => {
    const input = inputBlock.querySelector('.form-input');
    let collapseLabel = false;
    function toggleCollapse(collapse) {
      if (collapseLabel === collapse) return;
      if (!collapse && input.value !== '') return;
      collapseLabel = collapse;
      inputBlock.classList.toggle('form-input-block_collapsed');
    }
    if (input.value.trim() !== '') {
      toggleCollapse(true);
    }
    input.addEventListener('focusin', toggleCollapse.bind(null, true));
    input.addEventListener('focusout', toggleCollapse.bind(null, false));
    input.addEventListener('input', () => {
      if (!collapseLabel) {
        toggleCollapse(true);
      }
    });
    if (input.tagName === 'SELECT') {
      new Dropkick(input, {
        mobile: false,
        open: toggleCollapse.bind(null, true),
        close: toggleCollapse.bind(null, false),
        change: () => {
          const event = document.createEvent('Event');
          event.initEvent('input', true, true);
          input.dispatchEvent(event);
        },
      });
    }
  });
}

export default formInputs;
